<template>
  <div class="patient-snapshot">
    <button
      class="patient-snapshot__image"
      v-on:click="onClickPhoto"
      type="button"
    >
      <img
        alt="Изображение пациента"
        v-bind:src="file.snapshotUrl"
      />
    </button>
    <div class="patient-snapshot__info">
      <p class="patient-snapshot__title">{{ file.name }}</p>
      <div class="patient-snapshot__control-buttons">
        <button
          class="patient-snapshot__download"
          type="button"
          title="Скачать снимок"
          v-on:click.stop="onClickDownloadButton" />
        <button
          class="patient-snapshot__delete"
          type="button"
          title="Удалить снимок"
          v-on:click.stop="onClickDeleteButton" />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * @description Наименование события показа снимка.
 * @type {string}
 */
const NAME_SHOW_SNAPSHOT_EVENT = 'show-snapshot';

/**
 * @description Наименование события удаления снимка.
 * @type {string}
 */
const NAME_DELETE_SNAPSHOT_EVENT = 'delete-snapshot';

/**
 * @description Наименование события загрузки снимка.
 * @type {string}
 */
const NAME_DOWNLOAD_SNAPSHOT_EVENT = 'download-snapshot';

export default {
  /**
   * @description Компонент снимка пациента.
   */
  name: 'patient-snapshot',
  methods: {
    /**
     * @description Обработать события клика на фото
     * @returns {void}
     */
    onClickPhoto() {
      this.$emit(NAME_SHOW_SNAPSHOT_EVENT, this.file);
    },
    /**
     * @description Обработать события клика на кнопку удаления фотографии.
     * @returns {void}
     */
    onClickDeleteButton() {
      this.$emit(NAME_DELETE_SNAPSHOT_EVENT, this.file);
    },
    /**
     * @description Обработать события клика на кнопку загрузки фотографии.
     * @returns {void}
     */
    onClickDownloadButton() {
      this.$emit(NAME_DOWNLOAD_SNAPSHOT_EVENT, this.file);
    },
  },
  props: {
    /**
     * @description Файл
     * @type {Object|File}
     */
    file: {
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.patient-snapshot {
  width: 290px;
  height: 290px;
  &__info{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px 15px;
    height: 62px;
    font-size: 12px;
  }
  &__title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    overflow-wrap: anywhere;
  }
  &__control-buttons {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
  &__image {
    cursor: pointer;
    >img {
      width: min(100%, 290px);
      min-width: 250px;
      height: 220px;
      object-fit: contain;
    }
  }
  &__download {
    background-image: url("@/assets/img/download/download-arrow-grey.svg");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    width: 16px;
    height: 16px;
    padding: 0;
    cursor: pointer;
    &:hover {
      background-image: url("@/assets/img/download/download-arrow-blue.svg");
    }
  }
  &__delete {
    background-image: url("@/assets/img/cross/cross-rounded-grey.svg");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    width: 12px;
    height: 12px;
    cursor: pointer;
    &:hover {
      background-image: url("@/assets/img/cross/cross-rounded-blue.svg");
    }
  }
}

@media screen and (max-width: 480px) {
  .patient-snapshot {
    width: min(100%, 160px);
    height: 180px;
    text-align: center;
    &__image {
      img {
        width: min(100%, 140px);
        min-width: 80px;
        height: 110px;
      }
    }
    &__info {
      flex-direction: column;
      align-items: center;
      height: 65px;
    }
    &__title {
      -webkit-line-clamp: 2;
    }
    &__control-buttons {
      justify-content: center;
    }
  }
}

</style>
